import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash";
import DocumentCodeService from "services/DocumentCodeService";

export const getDCConfigs = createAsyncThunk(
  "document-code/getDCConfigs",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DocumentCodeService.getDCConfigs();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const saveDCConfigs = createAsyncThunk(
  "document-code/saveDCConfigs",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DocumentCodeService.saveDCConfigs(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const restoreDCDefaults = createAsyncThunk(
  "document-code/restoreDCDefaults",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DocumentCodeService.restoreDCDefaults();
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getDCPreview = createAsyncThunk(
  "document-code/getDCPreview",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DocumentCodeService.getDCPreview(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  documentCodeList: [],
  previewCode: {},
};
export const storeDocumentCodeSlice = createSlice({
  name: "document-code",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setDocumentCode: (state, action) => {
      state.documentCodeList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDCConfigs.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDCConfigs.fulfilled, (state, action) => {
        state.loading = false;
        state.documentCodeList = action.payload;
      })
      .addCase(getDCConfigs.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(saveDCConfigs.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveDCConfigs.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(saveDCConfigs.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(restoreDCDefaults.pending, (state) => {
        state.loading = true;
      })
      .addCase(restoreDCDefaults.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(restoreDCDefaults.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getDCPreview.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDCPreview.fulfilled, (state, action) => {
        state.loading = false;
        state.previewCode = action.payload;
      })
      .addCase(getDCPreview.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setDocumentCode } = storeDocumentCodeSlice.actions;

export default storeDocumentCodeSlice.reducer;
